interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): (number | "gap")[] {
  const pages: (number | "gap")[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "gap") {
      pages.push("gap");
    }
  }
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = buildPages(page, totalPages);

  return (
    <nav className="mt-10 flex items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 text-sm text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-left-s-line text-base" />
        </span>
        上一页
      </button>

      {pages.map((item, index) =>
        item === "gap" ? (
          <span
            key={`gap-${index}`}
            className="flex h-9 w-9 items-center justify-center text-sm text-foreground-500"
          >
            …
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`h-9 w-9 whitespace-nowrap rounded-md text-sm transition-colors ${
              item === page
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 text-foreground-700 hover:bg-background-100"
            }`}
          >
            {item}
          </button>
        ),
      )}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 text-sm text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-right-s-line text-base" />
        </span>
      </button>
    </nav>
  );
}